import { Typography } from "@mui/material";
import React, { useMemo } from "react";

const InfoItemLabel = ({
  children,
  fontSize,
  color = "#64748b",
  sx,
  labelUppercase = true,
  variant = "caption",
}) => {
  const styles = useMemo(() => {
    return {
      fontSize: fontSize,
      color,
      textTransform: labelUppercase ? "uppercase" : "none",
      letterSpacing: "0.5px",
      fontWeight: 400,
      ...sx,
    };
  }, [sx, fontSize, color, labelUppercase]);
  return (
    <Typography variant={variant} sx={styles}>
      {children}
    </Typography>
  );
};

export default InfoItemLabel;
